// extracted by mini-css-extract-plugin
export default {"progress-bar-loader":"ProgressBar_progress-bar-loader__d3ftC","barStripe":"ProgressBar_barStripe__ndySc"};